import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./component/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Polyfills object-fit
// @ts-ignore
var objectFitImages = require('object-fit-images');
if (!objectFitImages.supportsObjectFit) {
	objectFitImages();
}

// Only the collapsableGroup items
import CollapsableGroup from './component/CollapsableGroup/CollapsableGroup';
new CollapsableGroup();

// Only the questionAnswer navigation
import QuestionAnswer from './component/QuestionAnswer/QuestionAnswer';
new QuestionAnswer();

// Masthead Carousel
//
import mastheadCarousel from './component/MastheadCarousel/MastheadCarousel';
mastheadCarousel('.mastheadCarousel__items');

// Testimonial Carousel
import testimonialCarousel from './component/TestimonialCarousel/TestimonialCarousel';
testimonialCarousel('.testimonial__itemsCarousel');

// History Timeline Carousel
import timeline from './component/Timeline/Timeline';
timeline('.timeline__items');

// Image Carousel
import imageCarousel from './component/ImageCarousel/ImageCarousel';
imageCarousel('.imageCarousel__inner');


// Animations
import SiteAnimations from './component/SiteAnimation';
SiteAnimations.createInstance([
	{
		observedSelector: '.richContent__animationWrap',
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.pageFooter__copyright',
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	},
]);

import initComparisonTableLogic from '../blocks/ComparisonTable/ComparisonTable';
initComparisonTableLogic();

import initInternetSpeedQuizLogic from '../blocks/InternetSpeedQuiz/InternetSpeedQuiz';
initInternetSpeedQuizLogic();

import Gallery from './component/Gallery/Gallery';
new Gallery();

import allHail from './component/hfil';
allHail();

import instrumentCheckpoint from "./component/CheckpointInstrumentation";
instrumentCheckpoint();

import Orphans from './component/orphanage';
let orphan = [];
orphan.push('.callToAction__heading');
orphan.push('.callToAction__content p');
orphan.push('.masthead__content p');
orphan.push('[class*="intro"] p');
Orphans.adopt(orphan.join());

// checkpoint frontend overrides for address lookup form
import './component/checkpointOverrides';

import StickyElement from './component/StickyElement';
new StickyElement();

import "./component/markTransformedPhoneNumbers";
